// Experiências: status dos resgates, formatação e utilitários

export const voucherStatuses = {
  pending: { label: 'Aguardando aprovação', variant: 'warning', icon: 'bx bx-time-five' },
  approved: { label: 'Aprovada', variant: 'success', icon: 'bx bx-check-circle' },
  completed: { label: 'Concluída', variant: 'secondary', icon: 'bx bx-badge-check' },
  rejected: { label: 'Reprovada', variant: 'danger', icon: 'bx bx-x-circle' },
  canceled: { label: 'Cancelada', variant: 'danger', icon: 'bx bx-block' },
}

export function voucherStatus(status) {
  return voucherStatuses[status] || { label: String(status), variant: 'secondary', icon: 'bx bx-info-circle' }
}

export function formatPoints(value) {
  const number = Number(value) || 0
  return number.toLocaleString('pt-BR', { maximumFractionDigits: 0 }) + ' pts'
}

// Datas no padrão Y-m-d H:i:s para d/m/Y (com hora opcional)
export function formatDate(value, withTime) {
  if (!value) {
    return '–'
  }
  const text = String(value)
  if (!/^\d{4}-\d{2}-\d{2}/.test(text)) {
    return text
  }
  const date = text.substr(0, 10).split('-').reverse().join('/')
  return withTime && text.length >= 16 ? date + ' ' + text.substr(11, 5) : date
}

// Mensagem de erro de uma chamada à API: prioriza response.data.message
export function errorMessage(error, fallback) {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message
  }
  return fallback
}

// Chave de idempotência (UUID v4) sem dependência externa
export function uuid() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
  return [hex.substr(0, 8), hex.substr(8, 4), hex.substr(12, 4), hex.substr(16, 4), hex.substr(20, 12)].join('-')
}

// Cidade/UF do parceiro em uma linha
export function formatPlace(partner) {
  if (!partner) {
    return ''
  }
  return [partner.city, partner.state].filter(Boolean).join('/')
}
